// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IDriverMedicalCertificateWaiverType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class DriverMedicalCertificateWaiverType implements IDriverMedicalCertificateWaiverType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
        Returns Diabetes DriverMedicalCertificateWaiverType
    **/
    get Diabetes(): IDriverMedicalCertificateWaiverType {
        return this.FromId(1);
    }
    /**
        Returns Limb/Amputation DriverMedicalCertificateWaiverType
    **/
    get LimbAmputation(): IDriverMedicalCertificateWaiverType {
        return this.FromId(2);
    }
    /**
        Returns Vision DriverMedicalCertificateWaiverType
    **/
    get Vision(): IDriverMedicalCertificateWaiverType {
        return this.FromId(3);
    }
    /**
        Returns Qualified by Operation DriverMedicalCertificateWaiverType
    **/
    get QualifiedByOperation(): IDriverMedicalCertificateWaiverType {
        return this.FromId(4);
    }
    /**
        Returns National Registry DriverMedicalCertificateWaiverType
    **/
    get NationalRegistry(): IDriverMedicalCertificateWaiverType {
        return this.FromId(5);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Diabetes', displayValue: 'Diabetes', description: 'Diabetes', sortOrder: 999999, active: false });
        this._dictionary.add('2', { id: 2, value: 'LimbAmputation', displayValue: 'Limb/Amputation', description: 'Limb/Amputation', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Vision', displayValue: 'Vision', description: 'Vision', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'QualifiedByOperation', displayValue: 'Qualified by Operation', description: 'Qualified by operation of 49 CFR 391.64', sortOrder: 999999, active: false });
        this._dictionary.add('5', { id: 5, value: 'NationalRegistry', displayValue: 'National Registry', description: 'From National Registry', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IDriverMedicalCertificateWaiverType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IDriverMedicalCertificateWaiverType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDriverMedicalCertificateWaiverType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDriverMedicalCertificateWaiverType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IDriverMedicalCertificateWaiverType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        const get = (obj, path) => {
            if (path) {
                path = path.split('.');

                for (var i = 0, len = path.length - 1; i < len; i++) {
                    obj = obj[path[i]];
                }

                return obj[path[len]];
            }
            return obj;
        };

        const prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            const A = prime(a);
            const B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
